import numeral from 'numeral'

export function fNumber(number?: number | string): string {
  if (number?.toString().includes('.')) {
    const [amount, decimal] = number.toString().split('.')

    return numeral(amount).format('0,0') + '.' + decimal.slice(0, 2)
  }

  return numeral(number).format('0,0')
}

export function fCurrency(number: string | number | null) {
  if (!number) return '$0.00'

  return number ? numeral(number).format('$0,0.00') : '$0.00'
}

export const isDev = window.location.origin.includes('dev')
